import { useTranslation } from "react-i18next";
import { useState, useRef, useEffect } from "react";
import { Globe, Check } from "lucide-react";
import { LANGUAGES } from "@/i18n";

const LanguageSwitcher = ({ compact = false }) => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const current = LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0];

  const change = (code) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen(!open)}
        data-testid="lang-switcher-btn"
        className={`inline-flex items-center gap-1.5 text-sm font-medium text-zinc-700 hover:text-zinc-900 transition ${
          compact ? "px-2 py-1" : ""
        }`}
      >
        <Globe className="w-4 h-4" />
        <span className="hidden sm:inline">{current.flag}</span>
        <span className="hidden md:inline uppercase font-mono text-xs">{current.code}</span>
      </button>

      {open && (
        <div
          data-testid="lang-switcher-menu"
          className="absolute right-0 top-full mt-2 w-44 bg-white border border-zinc-200 shadow-xl z-50 py-1"
        >
          {LANGUAGES.map((l) => (
            <button
              key={l.code}
              onClick={() => change(l.code)}
              data-testid={`lang-option-${l.code}`}
              className={`w-full flex items-center justify-between px-4 py-2.5 text-sm hover:bg-zinc-50 transition ${
                current.code === l.code ? "font-semibold text-[#4F46E5]" : "text-zinc-700"
              }`}
            >
              <span className="inline-flex items-center gap-2">
                <span>{l.flag}</span>
                <span>{l.label}</span>
              </span>
              {current.code === l.code && <Check className="w-4 h-4" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
